import * as React from 'react';
import { st, classes } from './ControlHeader.st.css';
import Text from '../Text';
import InfoIcon from '../InfoIcon';
import TextButton from '../TextButton';
const ControlHeader = ({ dataHook, title, prefix, suffix, tooltipInfo, showInfo, disabled, maxLines = 1, }) => {
    return (React.createElement("div", { className: classes.root, "data-hook": dataHook },
        prefix && React.createElement("div", { className: classes.prefix }, prefix),
        title && (React.createElement(Text, { dataHook: "control-header-title", size: "small", weight: "thin", disabled: disabled, ellipsis: true, ellipsisProps: { maxLines: maxLines === 'auto' ? 0 : maxLines } }, title)),
        suffix && React.createElement("div", { className: classes.suffix }, suffix),
        tooltipInfo && (React.createElement(InfoIcon, { dataHook: "control-header-info-icon", disabled: disabled, className: st(classes.info, { visible: showInfo }), size: "small", tooltipProps: {
                dataHook: 'control-header-info-icon',
                content: [
                    tooltipInfo.text,
                    React.createElement(TextButton, { key: "link", onClick: tooltipInfo.onLinkClick, size: "tiny", weight: "thin" },
                        ' ',
                        tooltipInfo.linkText),
                ],
            } }))));
};
export default ControlHeader;
//# sourceMappingURL=ControlHeader.js.map